module.exports = __webpack_public_path__ + "static/media/bg_0.f166e07e.jpg";